import { createSlice } from "@reduxjs/toolkit";

const getInitialTheme = () => {
  const storedTheme = localStorage.getItem("theme_status");
  return storedTheme === "true"; 
};

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    mode: getInitialTheme()
  },
  reducers: {
    toggleThemeMode: (state, action) => {
      state.mode = action.payload;
      localStorage.setItem("theme_status", action.payload); 
    }
  }
});

export const { toggleThemeMode } = themeSlice.actions;
export default themeSlice.reducer;
